// extracted by mini-css-extract-plugin
export default {"base":"login_base__P-M6E","logo":"login_logo__Pfy7N","submit-button":"login_submit-button__ohVud"};